module.exports = __webpack_public_path__ + "static/media/img-02.0a5e174f.jpg";